import classNames from 'classnames/bind'

import Styles from './LayerTitle.module.scss'

import type {ReactNode} from 'react'

const cx = classNames.bind(Styles)

interface LayerTitleProps {
    title: string | ReactNode
    children?: ReactNode
    count?: string
    alignLeft?: boolean
    articleClassName?: string
}

/**
 * @param alignLeft : 좌측정렬 케이스(타이틀, 본문)
 */
const LayerTitle = ({title, children, count = '', alignLeft = false, articleClassName}: LayerTitleProps) => {
    return (
        <div className={cx('layer_title', {'align-left': alignLeft}, articleClassName)}>
            <div className={cx('title')}>
                <h3>{title}</h3>
                {count && <span className={cx('count')}>{count}</span>}
                {children}
            </div>
        </div>
    )
}

export default LayerTitle
